/**
 * Der Such-Index. Enthält die Suchbegriffe mit Seiten und Gewichtungen.
 *
 * @class service_v3sSearchIndex
 * @memberOf v3sWbtPlayerApp:tools:search
 */
angular.module('v3sWbtPlayerApp').factory('v3sSearchIndex', ["v3sSearchTerm", "$filter", function (v3sSearchTerm, $filter) {
    /**
     * Konstruktor. Erstellt einen leeren Suchindex.
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchIndex
     */
    var v3sSearchIndex = function () {
        this.terms = [];
    };

   /**
    * Fügt einen Begriff zum Suchindex hinzu. Wenn der Begriff bereits vorhanden ist, werden die
    * Pfade ergänzt und die Gewichte ggf. addiert.
    *
    * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchIndex
    * @param {string} term - der neue Begriff
    * @param {string[]} paths - die dazugehörigen Pfade
    * @param {number} weight - die Gewichtung
    * @param {string} type - die Art des Eintrags (page, lexikon, ...)
    */
    v3sSearchIndex.prototype.addTerm = function (term, paths, weight, type) {
        var i,
            termFound = false,
            lowerTerm = term.trim().toLocaleLowerCase();

        if (!lowerTerm) {
            return;
        }

        // Ggf. die Pfade einem vorhandenen Eintrag hinzufügen
        for (i = 0; i < this.terms.length; i++) {
            if (this.terms[i].term === lowerTerm) {
                this.terms[i].addPaths(paths, weight, type);
                termFound = true;
                break;
            }
        }

        // Wenn es keinen gibt, einen neuen erstellen
        if (!termFound) {
            this.terms.push(new v3sSearchTerm(lowerTerm, paths, weight, type));
        }
    }

    /**
     * Fügt eine Liste von Begriffen zum Suchindex hinzu. Wenn ein Begriff bereits vorhanden ist, werden die
     * Pfade ergänzt und die Gewichte ggf. addiert.
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchIndex
     * @param {Object} term - die neuen Begriffe in der Form { terms: string[], paths: string[] }
     * @param {number} weight - die Gewichtung
     * @param {string} type - die Art des Eintrags (page, lexikon, ...)
     */
    v3sSearchIndex.prototype.addTerms = function (data, weight, type) {
        if (data) {
            var i;
            for (i = 0; i < data.terms.length; i++) {
                this.addTerm(data.terms[i], data.paths[i], weight, type);
            }
        }
    }

    /**
     * Entfernt den gegebenen Pfad aus dem Index. Wenn ein Eintrag dadurch keinen Pfad mehr enthält,
     * wird dieser komplett entfernt
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchIndex
     * @param {number} path - der Pfad
     * @param {string} type - die Art des Eintrags (page, lexikon, ...)
     */
    v3sSearchIndex.prototype.removePath = function (path, type) {
        var term, i;

        for (i = this.terms.length - 1; i >= 0; i--) {
            term = this.terms[i];
            term.removePath(path, type);

            if (term.paths.length == 0) {
                this.terms.splice(i, 1);
            }
        }
    }

    /**
     * Sortiert die Suchbegriffe absteigend nach Gewicht und bei gleichem Gewicht alphabetisch.
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchIndex
     */
    v3sSearchIndex.prototype.sortTerms = function () {
        this.terms = $filter('orderBy')(this.terms, ["-maxWeight", "term"]);
    }

    return v3sSearchIndex;
}]);

/**
 * Ein Suchbegriff mit den dazugehörigen Seiten und der Gewichtung pro Seite.
 *
 * @class service_v3sSearchTerm
 * @memberOf v3sWbtPlayerApp:tools:search
 */
angular.module('v3sWbtPlayerApp').factory('v3sSearchTerm', [function () {
   /**
    * Konstruktor, erstellt einen neuen Suchbegriff mit initialem Begriff, Pfaden und Gewicht.
    *
    * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchTerm
    * @param {string} term - der Suchbegriff
    * @param {string[]} paths - die dazugehörigen Pfade
    * @param {number} weight - die Gewichtung
    * @param {string} type - die Art des Eintrags (page, lexikon, ...)
    */
    var v3sSearchTerm = function (term, paths, weight, type) {
        this.term = term;
        this.paths = [];
        this.maxWeight = weight;

        var i;
        for (i = 0; i < paths.length; i++) {
            this.paths.push({ path: paths[i], weight: weight, type: type });
        }
    };

    /**
     * Füge neue Pfade zu diesem Suchbegriff hinzu. Wenn ein Pfad bereits existiert, wird die
     * Gewichtung entsprechend addiert.
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchTerm
     * @param {string[]} paths - die neuen Pfade
     * @param {number} weight - die Gewichtung
     * @param {string} type - die Art des Eintrags (page, lexikon, ...)
     */
    v3sSearchTerm.prototype.addPaths = function (paths, weight, type) {
        var i, j, pathFound;

        for (i = 0; i < paths.length; i++) {
            pathFound = false;
            for (j = 0; j < this.paths.length; j++) {
                if (paths[i] == this.paths[j].path && type == this.paths[j].type) {
                    this.paths[j].weight += weight;
                    pathFound = true;
                    break;
                }
            }

            if (!pathFound) {
                this.paths.push({ path: paths[i], weight: weight, type: type });
            }
        }

        if (this.weight < weight) {
            this.weight = weight;
        }
    };

    /**
     * Entfernt einen Pfad von diesem Suchbegriff
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchTerm
     * @param {string} path - der Pfad
     * @param {string} type - die Art des Eintrags (page, lexikon, ...)
     */
    v3sSearchTerm.prototype.removePath = function (path, type) {
        var i,
            pathFound = false;

        for (i = 0; i < this.paths.length; i++) {
            if (path == this.paths[i].path && type == this.paths[i].type) {
                this.paths.splice(i, 1);
                return;
            }
        }
    };

    return v3sSearchTerm;
}]);